import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  allowOutOfStockSelection: false,
  brandClasses: {
    breadcrumbs: '',
    ctasWrapper: 'pt-2 space-y-4',
    details: 'lg:col-span-4 md:(col-span-5 row-start-2 row-end-5)',
    detailsSticky: 'md:pt-4',
    eSpotAboveAccordions: 'b-grey-70 pb-4 not-only-child:(b-t pt-4)',
    eSpotBelowSizes: 'mt-2',
    eSpotLazyAboveFooter: '',
    eSpotLazyBelowGallery: '',
    eSpotsAndReviews: 'mt-4 md:mt-8 space-y-8',
    gallery: 'lg:col-span-8 md:(col-span-7 row-start-1 row-end-3 pt-4)',
    grid: 'mb-12 md:(grid mb-8 items-start gap-4 cols-12)',
    gridFullWidth: 'col-span-12',
    gridPartialWidth: 'lg:col-span-8 md:col-span-7',
    heading: 'pt-4 lg:col-span-4 md:col-span-5 <lg:mb-4',
    headingProductName: 'text-lg lg:text-2xl',
    headingSticky: 'mb-8 lg:mb-4',
    klarnaPayments: 'mt-4',
    reviewsCount: 'hidden',
    reviewsItemsContainer: 'space-y-3',
    reviewsListContainer: 'space-y-3 mt-2',
    reviewsSearchForm: 'b b-grey-40 rounded-xs focus-within:b-grey-10',
    reviewsSearchInput: 'w-full b-0',
    reviewsSearchSortContainer: 'py-3 space-y-3',
    reviewsSearchSubmit: 'px-3',
    reviewsSearchWrapper: '',
    reviewsSnapshotWrapper: 'space-y-3',
    reviewsWrapper: 'text-sm',
    shopTheLookCta: 'justify-center',
    shopTheLookDialog: '',
    shopTheLookHeading: 'text-center',
    shopTheLookWrapper: 'mt-5',
    sizeAndFitButton: 'body-4 flex items-center gap-2 underlined'
  },
  breadcrumbsMaxItems: 2,
  details: {
    ctaVariant: 'secondary',
    favoriteCta: {
      variantSelected: 'secondary'
    }
  },
  disableGroupBy: true,
  quickshop: {
    dialogOptions: { size: { sm: 'lg' } },
  },
  reviews: {
    dialogOptions: {
      reviewWrite: { type: 'panel' }
    },
    recommendationRateThreshold: 74,
    pageSize: 10,
    iconSize: 'md',
    showFilters: true,
    showProsAndCons: false,
    showRatingBreakdown: false,
    showWriteReviewCta: false,
    showFilterPills: false
  },
  seoMetaImage: 'https://images.timberland.com/is/image/timberland/A17KC001-HERO',
  sizeAndFit: {
    showHeading: false,
    iconSize: {
      sm: 'sm',
      lg: 'md',
    }
  },
  shopTheLook: {
    dialogOptions: { type: 'panel', size: { sm: 'lg' } },
    mediaSize: {
      width: 120,
      height: 120
    },
    mediaTransformations: {
      alignFill: 'center',
      unSharpMask: 100
    },
    showLinkArrow: true,
    productSetImageThreshold: 4
  },
  showBreadcrumbsLastStep: false,
  swatches: {
    size: { sm: 'sm' },
    variant: 'rectangle'
  },
  tryItOn: {
    apparelUrl: 'https://sneaker-window.vyking.io/vyking-assets/customer/{brand}/ar-asset-packages/{productId}/offsets.json',
    brandClasses: {
      subtitle: 'subtitle-3 mb-2 text-sm fw-bold',
      vyking: '[&::part(qrcode)]:(relative left-a top-a flex transform-none ws-pre-wrap text-left text-sm lh-2 body-3 lh-1 w-full f-col) [&::part(qrcode-img)]:w-40'
    },
    config: '/vyking/modeld-3.bin',
    key: 'com.timberland',
    src: 'https://sneaker-window.vyking.io/vyking-apparel/1/vyking-apparel.js'
  }
} satisfies RecursivePartial<PdpConfig>
